import { baseService } from "service/base";

class StrategyService {
  load() {
    return baseService.get("/api/strategies");
  }

  new(strategy) {
    return baseService.post("/api/strategy", { strategy });
  }

  edit(strategyId, strategy) {
    return baseService.put(`/api/strategy/${strategyId}`, { strategy });
  }

  archive(strategyId, status) {
    return baseService.put(`/api/strategy/${strategyId}/archive`, {
      archive: status,
    });
  }
}

const strategyService = new StrategyService();

export { strategyService };
